var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-page',[_c('div',{staticClass:"mb-2"},[_c('b-btn',{staticClass:"pl-0",attrs:{"variant":"link","size":"lg","to":"/live"}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":"fa-light fa-chevron-left"}}),_vm._v(" All Livestreams ")],1)],1),(_vm.ready)?_c('div',[_c('livestream-dialog')],1):_c('div',[_c('generic-loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }